import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { commonActions } from 'srcReact/components/actions'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import Modal from '../Modal'
import AddInterestsToProfile from '../../popinsContent/AddInterestsToProfile'
import { useTranslation } from 'react-i18next'
import { handleHardReload } from 'srcReact/helpers/utils'

function Banner() {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const {
    common: { isMobile, isNative, bannerData }
  } = useSelector((state) => state)

  const closeBanner = (id) => {
    dispatch(commonActions.closeBannerData(id))
  }
  const [isInterestModalOpen, setIsInterestModalOpen] = useState(false)
  const [objectInterests, setObjectInterests] = useState([])
  const openInterestModal = (interests) => {
    setIsInterestModalOpen(true)
    setObjectInterests(interests)
  }
  const closeInterestModal = () => {
    setIsInterestModalOpen(false)
    setObjectInterests([])
  }

  useEffect(() => {
    if (bannerData?.length > 0) {
      bannerData.forEach((banner) => {
        //if duration is negative, do not close the banner automatically after certain duration
        if (banner.duration >= 0) {
          setTimeout(() => {
            dispatch(commonActions.closeBannerData(banner.id))
          }, banner.duration * 1000)
        }
      })
    }
  }, [JSON.stringify(bannerData)])

  return (
    <React.Fragment>
      {bannerData?.length > 0
        ? bannerData.map((banner, index) => {
            return (
              <div className={`${styles.bannerContainer} ${styles[`bannerContainer${index}`]}`}>
                {!isMobile && !isNative && (
                  <img
                    className={styles.character}
                    src={`${config.assetUrl}/images/${banner?.wizard?.toLowerCase()}.svg`}
                    alt=''
                  />
                )}

                <div className={styles.header}>
                  <div className={`${styles.yellowBorder} ${styles[`animation${banner.duration}s`]}`}></div>
                  <button type='button' className={styles.closeButton} onClick={() => closeBanner(banner.id)}>
                    <Icon name='close24' size='large24' />
                  </button>
                </div>
                <div className={styles.body}>
                  <p className={styles.text} dangerouslySetInnerHTML={{ __html: banner.content }} />
                  <div className={styles.actions}>
                    {banner &&
                      banner.cta &&
                      Object.keys(banner.cta).length > 0 &&
                      Object.values(banner.cta).map((action, index) => {
                        if (action?.interests?.length > 0) {
                          return (
                            <button
                              type='button'
                              className={index === 0 ? styles.primary : styles.secondary}
                              onClick={() => {
                                openInterestModal(action.interests)
                              }}>
                              {t('dashboard.pendingApproval.empty.btn')}
                            </button>
                          )
                        } else if (action?.button_url && !action.button_url.includes('reminder=true')) {
                          return (
                            <button
                              type='button'
                              className={index === 0 ? styles.primary : styles.secondary}
                              onClick={() => {
                                if (action.hardReload) {
                                  handleHardReload(action.button_url)
                                } else {
                                  window.location = action.button_url
                                }
                              }}>
                              {action.button_title}
                            </button>
                          )
                        }
                      })}
                  </div>
                </div>
              </div>
            )
          })
        : null}
      {isInterestModalOpen && (
        <Modal
          isOpen={isInterestModalOpen}
          title={t('groupHome.addInterestToProfile.title')}
          subTitle={t('groupHome.addInterestToProfile.subTitle')}
          handleClose={closeInterestModal}>
          <AddInterestsToProfile closeModal={closeInterestModal} interests={objectInterests} />
        </Modal>
      )}
    </React.Fragment>
  )
}

export default Banner
